import { useUserAuth } from 'providers/userAuth'

export const useShowConvertToQuote = () => {
  const { user } = useUserAuth()

  return user?.isTradeCapable
}
